module.exports = __webpack_public_path__ + "static/media/dislike.84085172.svg";